export const contractTypes = [
  { label: 'Файлы заявки', code: 'bs-files' },
  { label: 'Файлы клиента', code: 'client-files' },
  { label: 'Файлы кредитного конвейра', code: 'credit-flow-files' }
]
